import { DOMAIN_TO_LOCALE, LOCALE_SEPARATOR, MAPPED_LOCALES } from "../constants/locales";

interface CountryConfig {
  defaultLocale: string;
  tld: string;
  isMultiLang: boolean;
  locales: string[];
}

function populateBaseConfigs(map: Map<string, CountryConfig>) {
  for (const [tld, defaultLocale] of DOMAIN_TO_LOCALE.entries()) {
    const country = getCountryFromLocale(defaultLocale);
    if (country) {
      map.set(country, {
        defaultLocale,
        tld,
        isMultiLang: false,
        locales: [],
      });
    }
  }
}

function enrichWithLocales(map: Map<string, CountryConfig>) {
  for (const [locale, [_, country]] of MAPPED_LOCALES.entries()) {
    const config = map.get(country);
    if (config) {
      config.locales.push(locale);
      if (!config.isMultiLang && config.locales.length > 1) {
        config.isMultiLang = true;
      }
    }
  }
}

export const getCountryFromLocale = (locale: string): string => locale.split(LOCALE_SEPARATOR)[1] || "";

export function getLocaleConfigByCountry() {
  const configMap = new Map<string, CountryConfig>();

  populateBaseConfigs(configMap);
  enrichWithLocales(configMap);

  return configMap;
}

export function getLocaleQueryParam(): string | undefined {
  if (!globalThis.window) return undefined;

  const params = new URLSearchParams(globalThis.window.location.search);
  return params.get("locale") || undefined;
}
